import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Card } from "antd";
import { usePageTitle } from "helpers/usePageTitle";

const ResourcesPage = () => {
  usePageTitle("RESOURCES.PAGE_TITLE", `Resources - ${process.env.REACT_APP_PRODUCT}`);
  const [data, setData] = useState('')
  const appUiState = useSelector((state: any) => state.portal.uiState);

  useEffect(() => {
    const url = appUiState.Language === "en" ? 'https://healconnectdemo.z13.web.core.windows.net/resource-en.html' : 'https://healconnectdemo.z13.web.core.windows.net/resource-es.html'
    setData(url)
  }, [])

  return (
    <div data-testid="resources-page">
      <Card style={{ padding: "0px",margin: "0px" ,borderRadius:"0px"}}>
            <iframe width="100%" height="100%" frameBorder="0" src={data} title="Resources"></iframe>
      </Card>
    </div>
  );
};

export default ResourcesPage;
